<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 10:58:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-17 11:53:28
 * @Description: Banner
 -->

<template>
  <div class="banner-wrapper">
    <ul class="banner-content">
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-01.png" alt="" srcset="" />
        <h3 class="title">银行存管</h3>
        <p>接入存管银行，保证资金安全</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-02.png" alt="" srcset="" />
        <h3 class="title">多种服务</h3>
        <p>不同期限、不同收益率的多种产品服务</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-03.png" alt="" srcset="" />
        <h3 class="title">安全保障</h3>
        <p>防火墙双引擎架构，数据安全可靠</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-04.png" alt="" srcset="" />
        <h3 class="title">信息透明</h3>
        <p>运营数据、信息及时进行披露</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'banner'
};
</script>
<style lang="less" scoped>
.banner-wrapper {
  background: #fff;
  height: 444px;
  .banner-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .banner-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      height: 240px;
      padding: 30px 10px;
      img {
        width: 132px;
        height: 132px;
        margin-bottom: 30px;
      }
      h3 {
        font-family: 'PingFangSC-Medium';
        font-size: 20px;
        color: #2c6eff;
        line-height: 20px;
      }
      p {
        font-family: 'PingFangSC-Regular';
        font-size: 14px;
        color: #666666;
        text-align: center;
        line-height: 24px;
      }
      &:hover {
        background: #eee;
        img {
          transition: 0.4s linear;
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>
